<template>
  <div style="height: 100%">
    <div style="height: 100%; position: relative" class="box">
      <el-carousel v-if="accountNo=='01.01'" :height="screenheight" :interval="120000">
        <!--        线绕车间-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen99_241118_171356`"/>
        </el-carousel-item>
        <!--        线绕工时-->
<!--        <el-carousel-item>-->
<!--          <iframe-->
<!--              frameborder="0"-->
<!--              height="100%"-->
<!--              width="100%"-->
<!--              src="`${fullUrl}/datav/index.html#/preview?name=screen88_240703_202658"/>-->
<!--        </el-carousel-item>-->
        <!--        箔绕车间-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen100_241118_171641`"/>
        </el-carousel-item>
        <!--        箔绕工时-->
<!--        <el-carousel-item>-->
<!--          <iframe-->
<!--              frameborder="0"-->
<!--              height="100%"-->
<!--              width="100%"-->
<!--              src="`${fullUrl}/datav/index.html#/preview?name=screen90_240703_203601`"/>-->
<!--        </el-carousel-item>-->
        <!--滤波器车间-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen102_241118_172133`"/>
        </el-carousel-item>
        <!--        滤波器工时-->
<!--        <el-carousel-item>-->
<!--          <iframe-->
<!--              frameborder="0"-->
<!--              height="100%"-->
<!--              width="100%"-->
<!--              src="`${fullUrl}/datav/index.html#/preview?name=screen92_240703_204427`"/>-->
<!--        </el-carousel-item>-->
        <!--        电阻器-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen101_241118_171832`"/>
        </el-carousel-item>
        <!--        电阻器工时-->
<!--        <el-carousel-item>-->
<!--          <iframe-->
<!--              frameborder="0"-->
<!--              height="100%"-->
<!--              width="100%"-->
<!--              src="`${fullUrl}/datav/index.html#/preview?name=screen94_240703_204800`"/>-->
<!--        </el-carousel-item>-->
<!--        电阻箱看板-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen103_241118_172323`"/>
        </el-carousel-item>

      </el-carousel>
      <el-carousel v-if="accountNo=='02.01'" :height="screenheight" :interval="120000">
<!--        线绕-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen104_241118_172828`"/>
        </el-carousel-item>
<!--        箔绕-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen105_241118_173048`"/>
        </el-carousel-item>
<!--        钣金-->
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen106_241118_173404`"/>
        </el-carousel-item>
      </el-carousel>
      <div class="test" @click="fullScreen">
        <i v-if="!isFullscreen" title="全屏" class="el-icon-full-screen"/>
        <i v-else title="还原" class="el-icon-aim"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Productpectaculars",
    data() {
      return {
        screenheight: document.documentElement.clientHeight - 80 + "px",
        isFullscreen: false,
        accountNo: window.config.accountNo,
        fullUrl:window.config.fullServerUrl,
      };
    },

    mounted() {
      window.onresize = () => {
        if (!this.isFullscreen) {
          this.screenheight = document.documentElement.clientHeight - 80 + "px";
        } else {
          this.screenheight = document.documentElement.clientHeight + "px";
        }
      };
    },

    methods: {
      fullScreen() {
        let fullscreenEnabled =
          document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled;
        if (fullscreenEnabled) {
          let element = document.getElementsByClassName("box")[0];
          if (this.isFullscreen) {
            // 关闭全屏
            if (element.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            }
          } else {
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
            } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen();
            }
          }
          this.isFullscreen = !this.isFullscreen;
        }
      },
    },
  };
</script>

<style scoped>
.test {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9999;
}
i {
  font-size: 26px;
  color: #fff;
  cursor: pointer;
  display: none;
}
.box:hover i {
  display: block;
}
</style>
